import { render, staticRenderFns } from "./DRTabsListsDetails.vue?vue&type=template&id=6f38186d&"
import script from "./DRTabsListsDetails.vue?vue&type=script&lang=js&"
export * from "./DRTabsListsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports